import { fromJS } from 'immutable';

import { ApiTemplate, UserToken } from '../../../helper/HelperAuth'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientId) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiTemplate + 'flow/list-published';
    // const url = 'http://localhost:9988/apitemplate/flow/list-published';

    var paramBody = {
        "client_id": clientId
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    }; 

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS({});

        try{
            var resJson = await response.json()
            if(resJson !== '' || resJson !== null){
                data = fromJS(resJson);
                data = data.get('data');
            }else{
                data = fromJS({});
            }    
        }catch(ex){
            data = fromJS({});
        }
    }

    return data;
};